import { authentification } from './firebase-config';
import { signInWithPopup, GoogleAuthProvider } from 'firebase/auth';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { FcGoogle } from 'react-icons/fc';
import shareVideo from '../assets/itachi.mp4';
import logo from '../assets/logowhite.png';
import { client } from '../client';

function App() {
	const navigate = useNavigate();

	const signinwithgoogle = () => 
	{
		const provider = new GoogleAuthProvider();
		signInWithPopup(authentification, provider)
			.then((response) => {
				localStorage.setItem('user', JSON.stringify(response.user));

				const { displayName, uid, photoURL } = response.user;
				console.log(response.user)
				const doc = {
					_id: uid,
					_type: 'user',
					userName: displayName,
					image: photoURL
				};

				client.createIfNotExists(doc).then(() => {
					navigate('/', { replace: true });
				});
			})
			.catch((error) => {
				console.log(error);
			});



	};

	const demoLogin=()=>{
		navigate('/', { replace: true });
	}

	return (
		<div className="flex justify-start items-center flex-col h-screen">
			<div className=" relative w-full h-full">
				<video
					src={shareVideo}
					type="video/mp4"
					loop
					controls={false}
					muted
					autoPlay
					className="w-full h-full object-cover"
				/>

				<div className="absolute flex flex-col justify-center items-center top-0 right-0 left-0 bottom-0 ">
					<div className="p-1">
						<img src={logo} width="350px" />
					</div>

					<div className="shadow-2xl">
						<button
							type="button"
							className="bg-mainColor flex justify-center items-center p-3 rounded-lg cursor-pointer outline-none"
							onClick={signinwithgoogle}
						>
							<FcGoogle className="mr-1" /> Sign in with google
						</button>

						<button
							type="button"
							className=" ml-1 mt-3 bg-mainColor flex justify-center items-center p-3 rounded-lg cursor-pointer outline-none"
							onClick={demoLogin}
						>DEMO LOGIN<br/>
						(VISIT ONLY HOME)
						</button>
					</div>
				</div>
			</div>
		</div>
	);
}

export default App;
